import http from '@/services/http';

const analysisImportMapping = {
  index(filter, config = {}) {
    return http.request({
      method: 'get',
      url: '/analysis-import-mappings',
      params: { filter },
      ...config,
    });
  },
  count(where, config = {}) {
    return http.request({
      method: 'get',
      url: '/analysis-import-mappings/count',
      params: { where },
      ...config,
    });
  },
  create(data) {
    return http.request({
      method: 'post',
      url: '/analysis-import-mappings',
      data,
    });
  },
  patch(id, data) {
    return http.request({
      method: 'patch',
      url: `/analysis-import-mappings/${id}`,
      data,
    });
  },
  delete(id) {
    return http.request({
      method: 'delete',
      url: `/analysis-import-mappings/${id}`,
    });
  },
};

export default analysisImportMapping;
